<template>
    <div>
        <!-- 面包屑导航 -->
        <breadcrumb-top :breadcrumbConfig="dataList" isBack="1"></breadcrumb-top>
        <!-- 面包屑导航 -->
        <div class="content c-top">
            <breadcrumb-search :breadcrumbSearch="searchList"></breadcrumb-search>
            <div>
                <el-form :inline="true" :model="searchForm" ref="searchForm" size="small">
                    <el-form-item label="商品名称" prop="name">
                        <el-input style="width: 232px" v-model="searchForm.name" placeholder="请输入商品名称" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="商品编号" prop="goodsNo">
                        <el-input style="width: 232px" v-model="searchForm.goodsNo" placeholder="请输入商品编号"
                            clearable></el-input>
                    </el-form-item>
                    <el-form-item label="状态" prop="status">
                        <el-select style="width: 232px" v-model="searchForm.status" placeholder="请选择状态" filterable
                            clearable>
                            <el-option label="启用" value="1"></el-option>
                            <el-option label="禁用" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="活动时间" prop="activateStartTime">
                        <el-date-picker v-model="value1" style="width: 232px" type="daterange" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item class="form-btn">
                        <el-button type="primary" @click="fetchData('search')">查询</el-button>
                        <el-button type="primary" plain @click="fetchData('reset')">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="content">
            <div class="title">
                <h3>列表数据</h3>
                <div style="display:flex">
                    <!-- <div class="u-btn" @click="lookQCode">生成二维码</div> -->
                    <div class="u-btn" @click="pUp('0')">批量删除</div>
                    <el-button type="primary" @click="options('add')" size="small" icon="el-icon-plus">新增商品</el-button>
                    <el-button type="primary" @click="isS = true" size="small" icon="el-icon-setting">设置活动</el-button>
                </div>
            </div>
            <div id="base-list">
                <lb-table v-horizontal-scroll="'always'" :column="columns" :data="list" pagination :total="page.totalNum"
                    layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20, 30, 50]"
                    :current-page.sync="page.pageNo" :page-size="page.pageSize" @selection-change="onMultipleSelection"
                    @size-change="handleSizeChange" @p-current-change="handleCurrentChange">
                </lb-table>
            </div>
        </div>
        <el-dialog title="温馨提示" :visible.sync="isD" width="518px" :append-to-body="true" top="calc(50vh - 100px)">
            <template>
                <div class="info" style="text-align: left">
                    <i class="el-icon-warning" style="color: orange; font-size: 20px"></i>
                    是否确认删除，删除后数据不可恢复！
                </div>
                <div style="display: flex; justify-content: end; margin-top: 24px">
                    <div class="info-q" @click="isD = false">取消</div>
                    <div class="info-s" @click="submitD">确定</div>
                </div>
            </template>
        </el-dialog>
        <el-dialog title="秒杀设置" :visible.sync="isS" width="518px" :append-to-body="true">
            <el-form ref="form" label-width="100px" class="info-form" style="margin-top: 22px" :rules="rules" :model="form">
                <el-form-item label="活动页面图" prop="banner">
                    <upload-picture :imageUrl="form.banner" :width="'108px'" :height="'108px'"
                        @getUrl="getImage($event)"></upload-picture>

                </el-form-item>
                <el-form-item>
                    <div class="p-info">图片尺寸：建议上传750px*400px，每张上传大小不得超过2M,支持jpg、jpeg、png格式</div>
                </el-form-item>
            </el-form>
            <div style="display: flex; justify-content: end; margin-top: 24px">
                <div class="info-q" @click="isS = false">取消</div>
                <div class="info-s" @click="submitSetting">确定</div>
            </div>
        </el-dialog>
        <el-dialog :title="optionsTag" :append-to-body="true" :close-on-click-modal="false" :visible.sync="dialogTags"
            width="518px">
            <el-form ref="form" label-width="110px" class="info-form" style="margin-top: 22px" :rules="rules" :model="form"
                v-if="!isLook">
                <el-form-item label="标签类目" prop="status">
                    <el-select style="width: 100%" v-model="form.status" placeholder="请选择标签类目" filterable clearable>
                        <el-option label="人群" value="true"></el-option>
                        <el-option label="生日" value="false"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="标签分类" prop="status">
                    <el-select style="width: 100%" v-model="form.status" placeholder="请选择标签分类" filterable clearable>
                        <el-option label="人群" value="true"></el-option>
                        <el-option label="生日" value="false"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="标签名称" prop="tagName">
                    <el-input placeholder="请输入标签名称" v-model="form.tagName" style="width: 100%"></el-input>
                </el-form-item>
                <el-form-item label="排序" prop="tagName">
                    <el-input placeholder="请输入排序" v-model="form.tagName" style="width: 100%"></el-input>
                </el-form-item>
                <el-form-item label="是否对外展示" prop="status">
                    <el-radio v-model="radio" label="1">是</el-radio>
                    <el-radio v-model="radio" label="2">否</el-radio>
                </el-form-item>
                <el-form-item label="状态" prop="status">
                    <el-radio v-model="radio" label="1">启用</el-radio>
                    <el-radio v-model="radio" label="2">禁用</el-radio>
                </el-form-item>
            </el-form>
            <el-form ref="form" label-width="110px" class="info-form" style="margin-top: 22px" :rules="rules" :model="form"
                v-else>
                <el-form-item label="标签类目" prop="status">
                    7878
                </el-form-item>
                <el-form-item label="标签分类" prop="status">
                    7897
                </el-form-item>
                <el-form-item label="标签名称" prop="tagName">
                    77777
                </el-form-item>
                <el-form-item label="排序" prop="tagName">
                    7897
                </el-form-item>
                <el-form-item label="是否对外展示" prop="status">
                    是
                </el-form-item>
                <el-form-item label="状态" prop="status">
                    启用
                </el-form-item>
            </el-form>
            <div style="display: flex; justify-content: end; margin-top: 24px">
                <div class="info-q" @click="dialogTags = false">取消</div>
                <div class="info-s" @click="dialogTags = false">确定</div>
            </div>
        </el-dialog>
        <el-dialog :title="optionsTitle" :append-to-body="true" :close-on-click-modal="false" :visible.sync="dialogGoods"
            width="60%">
            <div v-if="isLook">

                <el-form :inline="true" :model="searchForm" ref="searchForm1" size="small" style="margin-top:20px">
                    <el-form-item>
                        <div style="display:flex">
                            <el-button :type="gType == '1' ? 'primary' : ''" size="small"
                                @click="selectG('1')">普通商品</el-button>
                            <el-button :type="gType == '2' ? 'primary' : ''" size="small"
                                @click="selectG('2')">礼包商品</el-button>
                        </div>
                    </el-form-item>
                    <el-form-item label="" prop="tagName">
                        <el-input style="width: 232px" v-model="name" placeholder="请输入商品名称/商品编号" clearable></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="商品编号" prop="tagName">
                        <el-input style="width: 232px" v-model="goodsNo" placeholder="请输入商品编号" clearable></el-input>
                    </el-form-item> -->
                    <el-form-item class="form-btn">
                        <el-button type="primary" @click="fetchData1('search')">查询</el-button>
                        <el-button type="primary" plain @click="fetchData1('reset')">重置</el-button>
                    </el-form-item>
                </el-form>
                <el-table :data="goodsList" v-if="gType == '1'" ref="multipleTable" border :header-cell-style="{
                    'text-align': 'left',
                    background: '#F8F8F8',
                    color: '#333333',
                }">
                    <el-table-column prop="goodsName" label="商品信息">
                        <template slot-scope="scope">
                            <div style="display: flex">
                                <img :src="scope.row.image" style="width: 72px; height: 56px; margin-right: 12px" alt="" />
                                <div style="
                    font-size: 14px;
                    min-height: 56px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                  ">
                                    <p style="color: #333333;text-align:left">{{ scope.row.name }}</p>
                                    <p style="color: #999999;text-align:left">
                                        商品编号：{{ scope.row.goodsNo }}
                                    </p>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="商品类型" width="200px">
                        <template slot-scope="scope">
                            {{ scope.row.typeLabel }}
                        </template>
                    </el-table-column>
                    <el-table-column label="价格" width="200px">
                        <template slot-scope="scope">
                            {{ scope.row.minPrice }}~{{ scope.row.maxPrice }}
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="100px">
                        <template slot="header">
                            <div style="text-align:center">操作</div>
                        </template>
                        <template slot-scope="scope">
                            <div style="text-align: center;margin-left:10px">
                                <div class="btn-y" v-if="scope.row.selected" @click="handleSelectGoods(scope)">已选取</div>
                                <div class="btn-s" v-else @click="handleSelectGoods(scope)">选取</div>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div v-if="gType == '1'" style="
            display: flex;
            justify-content: end;
            align-items: center;
            height: 42px;
          ">
                    <el-pagination background @size-change="onGoodsSizeChange" @current-change="onGoodsCurrentChange"
                        :current-page="goodsPageNo" :page-sizes="[5, 10, 20]" :page-size="goodsPageSize"
                        layout="total, sizes, prev, pager, next, jumper" :total="goodsTotalNum">
                    </el-pagination>

                </div>
                <el-table :data="goodsList1" v-if="gType == '2'" ref="multipleTable" border :header-cell-style="{
                    'text-align': 'left',
                    background: '#F8F8F8',
                    color: '#333333',
                }">
                    <el-table-column prop="goodsName" label="商品信息">
                        <template slot-scope="scope">
                            <div style="display: flex">
                                <img :src="scope.row.images" style="width: 72px; height: 56px; margin-right: 12px" alt="" />
                                <div style="
                    font-size: 14px;
                    min-height: 56px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                  ">
                                    <p style="color: #333333;text-align:left">{{ scope.row.name }}</p>
                                    <p style="color: #999999;text-align:left">
                                        商品编号：{{ scope.row.code }}
                                    </p>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="商品类型" width="200px">
                        <template slot-scope="scope">
                            礼包商品
                        </template>
                    </el-table-column>
                    <el-table-column label="价格" width="200px">
                        <template slot-scope="scope">
                            {{ scope.row.price }}
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="100px">
                        <template slot="header">
                            <div style="text-align:center">操作</div>
                        </template>
                        <template slot-scope="scope">
                            <div style="text-align: center;margin-left:10px">
                                <div class="btn-y" v-if="scope.row.selected" @click="handleSelectGoods1(scope)">已选取
                                </div>
                                <div class="btn-s" v-else @click="handleSelectGoods1(scope)">选取</div>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div v-if="gType == '2'" style="
            display: flex;
            justify-content: end;
            align-items: center;
            height: 42px;
          ">
                    <el-pagination background @size-change="onGoodsSizeChange1" @current-change="onGoodsCurrentChange1"
                        :current-page="goodsPageNo1" :page-sizes="[5, 10, 20]" :page-size="goodsPageSize1"
                        layout="total, sizes, prev, pager, next, jumper" :total="goodsTotalNum1">
                    </el-pagination>
                </div>
            </div>
            <div v-if="isLook" style="font-weight:bold;color: #333333;font-size:18px">已选商品</div>
            <el-table border :data="goodsL" :span-method="objectSpanMethod" style="width: 100%; margin-top: 20px"
                :header-cell-style="{
                    'text-align': 'center',
                    background: '#F8F8F8',
                    color: '#333333',
                }" :cell-style="{ 'text-align': 'center' }">

                <el-table-column prop="name" label="商品名称">
                </el-table-column>
                <el-table-column prop="goodsSkuName" label="商品规格">
                </el-table-column>
                <el-table-column prop="retailPrice" label="价格">
                </el-table-column>
                <el-table-column prop="seckillPrice" label="秒杀价">
                    <template slot="header">
                        <div><span style="color:red;margin-right:4px">*</span>秒杀价</div>
                    </template>
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.seckillPrice" size="small" placeholder="请输入秒杀价"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="num" label="活动库存">
                    <template slot="header">
                        <div><span style="color:red;margin-right:4px">*</span>活动库存</div>
                    </template>
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.seckillStock" size="small" placeholder="请输入活动库存"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="num" label="虚拟销量">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.sellInitNum" size="small" placeholder="请输入虚拟销量"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="num" label="商品状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.skuStatus == 1">上架</span>
                        <span v-else>下架</span>
                    </template>
                </el-table-column>
            </el-table>
            <el-form style="margin-top:20px">
                <el-form-item label="运费设置">
                    <!-- <label slot="label">
                        <div><span style="color:red">*</span>运费设置</div>
                    </label> -->
                    <el-select style="width: 442px" v-model="shippingTemplateId" @change="getTransportModel" clearable
                        placeholder="请选择运费模板">
                        <el-option v-for="item in models" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>

                </el-form-item>
                <number v-if="detail.calculType == 1" :isEdit="false" :tableData="tableData" :freight="detail.freight"
                    style="width:100%!important" :baseNumber="detail.baseNumber" :addNum="detail.addNum"
                    :addPrice="detail.addPrice"></number>
                <weight v-if="detail.calculType == 2" :isEdit="false" :tableData="tableData" :freight="detail.freight"
                    style="width:100%!important" :baseNumber="detail.baseNumber" :addNum="detail.addNum"
                    :addPrice="detail.addPrice"></weight>
                <free-delivery v-if="tableDataF.length != 0" :tableData="tableDataF"
                    style="margin-top: 10px;width:100%!important" :isEdit="false"></free-delivery>
                <el-form-item label="活动时间" style="margin-top:20px">
                    <label slot="label">
                        <div><span style="color:red">*</span>活动时间</div>
                    </label>
                    <el-date-picker v-model="value3" style="width: 442px" type="datetimerange" range-separator="至"
                        start-placeholder="开始时间" end-placeholder="结束时间" format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>

                </el-form-item>
                <el-form-item label="排序" label-width="72px">
                    <div style="display:flex">
                        <el-input style="width: 442px" placeholder="请输入排序" v-model="sort"></el-input>
                        <div style="font-size:12px;color:#c6c9d1;margin-left:10px">数字最小排序最上方</div>
                    </div>

                </el-form-item>
            </el-form>
            <div style="display: flex; justify-content: end; margin-top: 24px">
                <div class="info-q" @click="dialogGoods = false">取消</div>
                <div class="info-s" @click="submitG">确定</div>
            </div>
        </el-dialog>
        <el-dialog title="生成二维码" :visible.sync="isQcode" width="518px" :append-to-body="true">
            <template>
                <div style="text-align: center;">
                    <img :src="qCode" style="width: 200px;height: 200px; display: block; margin: 0 auto;" />
                </div>
                <div style="display: flex; justify-content: end; margin-top: 24px">
                    <div class="info-s"><a :href="qCode" style="color:white;text-decoration: none;">导出</a>
                    </div>
                </div>
            </template>
        </el-dialog>
    </div>
</template>
<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
import LbTable from '../../../components/lb-table/lb-table'
import number from '@/pages/shopManagement/components/number.vue'
import weight from '@/pages/shopManagement/components/weight.vue'
import freeDelivery from '@/pages/shopManagement/components/freeDelivery.vue'
import uploadPicture from '@/components/upload/mallPicture1.vue'
export default {
    components: {
        breadcrumbTop,
        breadcrumbSearch,
        LbTable,
        number,
        weight,
        freeDelivery,
        uploadPicture
    },
    data() {
        return {
            isQcode: false,
            qCode: '',
            value3: [],
            tableData: [],
            tableDataF: [],
            shippingTemplateId: '',
            detail: {},
            models: [
                // {
                //     id: null,
                //     name: '包邮'
                // }
            ],
            name: '',
            goodsNo: '',
            gType: '1',
            goodsL: [

            ],
            isS: false,
            sTitle: '批量停用提示',
            sContent: '启用',
            dialogGoods: false,
            radio: '1',
            optionsTag: '新增标签',
            form: {
                id: '',
                tagImg: '',
                tagName: '',
                status: '',
                sort: '',
                banner: ''
            },
            rules: {
                tagName: [
                    { required: true, message: '请输入标签名称', trigger: 'blur' },
                ],
                tagImg: [
                    { required: true, message: '请上传标签图片', trigger: 'change' },
                ],
                sort: [
                    { required: true, message: '请输入排序数字', trigger: 'blur' },
                ],
                status: [
                    { required: true, message: '请选择状态', trigger: 'change' },
                ],
            },
            goodsList: [],//商品数据
            goodsPageNo: 1,//商品表格页数
            goodsPageSize: 5,//商品表格每页显示条数
            goodsTotalNum: 0,//商品表格总条数
            goodsList1: [],//礼包商品数据
            goodsPageNo1: 1,//商品表格页数
            goodsPageSize1: 5,//商品表格每页显示条数
            goodsTotalNum1: 0,//商品表格总条数
            seletedGoods: [],//已选商品列表
            seletedGoods1: [],//已选商品列表
            dialogTags: false,
            isS: false,
            dataList: {
                list: [
                    { title: '营销管理', path: '', type: '0' },
                    { title: '秒杀活动', path: '/marketingManagement/flashActivity', type: '1' }
                ]
            },
            searchList: {
                list: [
                    { title: '秒杀活动', path: '', type: '0' },
                    { title: '数据筛选', path: '', type: '1' }
                ]
            },
            list: [],
            searchForm: {
                id: '',
                name: '',
                status: '',
                goodsNo: '',
                activateStartTime: "",
                activateEndTime: '',
                pageNo: 1,
                pageSize: 10
            },
            value1: [],
            value2: [],
            brandList: [],
            columns: [
                { type: 'selection', minWidth: '80', fixed: 'left' },
                {
                    label: '排序', prop: 'sort', minWidth: '80',
                    // render: (h, scope) => {
                    //     return (
                    //         <div>
                    //             {scope.$index + 1}
                    //         </div >
                    //     )
                    // }
                },
                {
                    label: '商品编号', prop: 'goodsNo', minWidth: '100',
                    render: (h, scope) => {
                        return (
                            <div>
                                <span style='color:#2D46EE;cursor:pointer' onClick={() => { }}>{scope.row.goodsNo}</span>
                            </div >
                        )
                    }
                },
                {
                    label: '商品图片', prop: 'goodsCount', minWidth: '100',
                    render: (h, scope) => {
                        return (
                            <div>
                                <el-image style="width:64px;height:64px;margin-right:8px;" src={scope.row.mainImageArr[0]} preview-src-list={scope.row.mainImageArr} lazy></el-image>
                            </div>
                        )
                    }
                },
                { label: '商品名称', prop: 'name', minWidth: '130' },
                {
                    label: '活动时间', prop: 'time', minWidth: '300',
                    render: (h, scope) => {
                        return (
                            <div>
                                {scope.row.activateStartTime}-{scope.row.activateEndTime}
                            </div>
                        )
                    }
                },
                {
                    label: '秒杀价', prop: 'platformName', minWidth: '120',
                    render: (h, scope) => {
                        return (
                            <div>
                                ￥{scope.row.seckillPriceMin}-{scope.row.seckillPriceMax}
                            </div>
                        )
                    }
                },
                { label: '库存', prop: 'stock', minWidth: '120' },
                { label: '实际销售', prop: 'salesVolume', minWidth: '120' },
                { label: '虚拟总销售数', prop: 'virtualSalesVolume', minWidth: '120' },
                {
                    label: '状态', prop: 'statusLabel', minWidth: '130',
                    render: (h, scope) => {
                        let vv = ''
                        if (scope.row.statusL == '启用') {
                            vv = <p style="color:#303033;font-size:14px;display:flex;justify-content:center;"><div style="width: 10px;height: 10px;background: #13CE4B;border-radius: 50%;opacity: 1;margin-top:7px;margin-right:4px"></div>
                                <div>{scope.row.statusL}</div>
                            </p>
                        } else {
                            vv = <p style="color:#303033;font-size:14px;display:flex;justify-content:center;"><div style="width: 10px;height: 10px;background:  #F63C56;border-radius: 50%;opacity: 1;margin-top:7px;margin-right:4px"></div>
                                <div>{scope.row.statusL}</div>
                            </p>
                        }
                        return (
                            <div> {vv}</div>
                        )
                    }
                },
                {
                    label: '操作',
                    minWidth: '100',
                    fixed: 'right',
                    render: (h, scope) => {
                        return (
                            <div>
                                <span style='color:#2D46EE;cursor:pointer;margin-right:10px' onClick={() => { this.options('edit', scope.row) }}>编辑</span>
                                <span style='color:#2D46EE;cursor:pointer' onClick={() => { this.deleteD(scope.row.id) }}>删除</span>
                            </div >
                        )
                    }
                }],
            page: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
            page1: { list: [], pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
            goodsSearch: {
                tagId: '',
                pageNo: 1,
                pageSize: 10,
            },
            exporting: false,
            sName: '启用',
            isStatus: '',
            tagId: null,
            isD: false,
            isLook: true,
            optionsTitle: '选择商品',
            image: '',
            sort: '',
            dId: [],
            dId1: [],
            isAlot: true,
            eId: '',
            sType: '1'
        }
    },
    created() {
        // this.getPageList()
        this.getInfo()
    },
    beforeRouteEnter(to, from, next) {
        if (from.name == 'addTag') {
            next(vm => {
                vm.getPageList();
            });
        } else {
            next(vm => {
                vm.getPageList();
            });
        }
    },
    methods: {
        lookQCode() {
            this.axios.post('/coupon/getCouponQrInfo', { "qrInfo": "{\"couponId\":\"195\"}" }).then(res => {
                if (res.code == 0) {
                    this.isQcode = true
                    this.qCode = res.data.url
                }
            })
        },
        getInfo() {
            this.axios.post('/marketActivateSeckill/seckillInfo', {})
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        this.form.banner = res.data.image
                    }
                })
        },
        submitD() {
            let dId = []
            if (this.isAlot) {
                dId = this.dId1
            } else {
                dId = this.dId
            }
            let data = {
                id: 4,
                goodsId: dId,
                isDelete: 1,
                status: 2
            }
            this.axios.post('/marketActivate/deleteGoods', data)
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        this.$message.success('删除成功')
                        this.getPageList()
                        this.isD = false
                    }
                })
        },
        deleteD(id) {
            this.isD = true
            this.isAlot = false
            this.dId = []
            this.dId.push(id)
        },
        submitG() {
            let goodsL = []
            if (this.sType == 1) {
                goodsL = this.goodsL
            } else {
                this.goodsL.forEach(item => {
                    item.goodsSku = null
                })
                goodsL = this.goodsL
            }
            if (goodsL.length == 0) {
                this.$message.warning('请选择商品')
                return
            }
            // let tempArr = []
            goodsL.forEach(item => {
                if (item.seckillPrice == null) {
                    Object.assign(item, { seckillPrice: '' })
                }
                if (item.seckillStock == null) {
                    Object.assign(item, { seckillStock: '' })
                }
            })
            console.log(goodsL)
            let isS = goodsL.every(item => String(item.seckillPrice) != '' && String(item.seckillStock) != '')
            console.log(isS)
            if (!isS) {
                this.$message.warning('请填写商品秒杀价或秒杀库存')
                return
            }
            if (this.value3.length != 0) {
                this.activateStartTime = this.value3[0]
                this.activateEndTime = this.value3[1]
            } else {
                this.$message.warning('请选择活动时间')
                return
            }
            let shippingTemplateId = '0'
            if (this.shippingTemplateId == '' || this.shippingTemplateId == null) {
                shippingTemplateId = '0'
            } else {
                shippingTemplateId = this.shippingTemplateId
            }
            let data = {
                goodsId: this.seletedGoods[0],
                giftId: this.seletedGoods1[0],
                skuList: goodsL,
                sort: this.sort,
                activateStartTime: this.activateStartTime,
                activateEndTime: this.activateEndTime,
                shippingTemplateId: shippingTemplateId
            }
            if (this.optionsTitle == '活动商品设置') {
                data.id = this.eId
            }
            this.axios.post('/marketActivateSeckill/addGoods', data)
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        if (this.optionsTitle == '选择商品') {
                            this.$message.success('添加成功')
                        } else {
                            this.$message.success('编辑成功')
                        }
                        this.dialogGoods = false
                        this.getPageList()
                    }
                })
        },
        getModelsList() {
            let data = {
                pageNo: 1,
                pageSize: 1000
            }
            this.axios.post('/shippingTemplate/pageList', data)
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        let arr = []
                        let obj = {
                            id: 0,
                            name: '无'
                        }
                        arr.push(obj)
                        this.models = arr.concat(res.data.list)
                    }
                })
        },
        //获取模板详情
        getTransportModel(val) {
            console.log(val)
            if (!val) {
                this.detail = {}
                this.tableDataF = []
                return
            }
            let data = {
                id: val
            }
            this.axios.post('/shippingTemplate/get', data)
                .then(res => {
                    if (res.code == 0) {
                        this.detail = res.data ? res.data : null
                        this.tableData = this.detail ? this.detail.regions : []
                        if (this.tableData) {
                            this.tableData.forEach(item => {
                                Object.assign(item, { address: item.betterAddress })
                                if (item.regionJson) {
                                    Object.assign(item, { addressData: JSON.parse(item.regionJson) })
                                }

                            })
                        }


                        this.tableDataF = this.detail && this.detail.freeList ? this.detail.freeList : []
                        if (this.tableDataF) {
                            this.tableDataF.forEach(item => {
                                Object.assign(item, { address: item.betterAddress })
                                Object.assign(item, { addressData: JSON.parse(item.regionJson) })
                            })
                        }

                        // this.arr = []
                        // if (this.detail) {
                        //   this.arr.push(String(this.detail.isFree))
                        // }
                        this.$forceUpdate()
                    }
                })

        },
        //选择商品
        handleSelectGoods(scope) {
            this.seletedGoods = []
            if (!scope.row.selected) {
                for (let i = 0; i < this.goodsList.length; i++) {
                    if (i == scope.$index) {
                        this.goodsList[scope.$index].selected = !this.goodsList[scope.$index].selected
                    } else {
                        this.goodsList[i].selected = false;
                    }
                }
                this.getSkuList(scope.row.id, '1', scope.row.name)
                this.seletedGoods.push(scope.row.id)
            } else {
                this.goodsList[scope.$index].selected = false;
                this.goodsL=[]
            }
            console.log(this.seletedGoods)

            this.$forceUpdate()
        },
        getSkuList(id, type, name) {
            this.goodsL = []
            let data = {
                id: id,
                type: type,
            }
            this.axios.post('/goods/secKillSkuList', data).then(res => {
                if (res.code == 0) {
                    if (type == 1) {
                        res.data.forEach(item => {
                            item.name = name
                            if (item.seckillPrice) {
                                item.seckillPrice = Number(item.seckillPrice).toFixed(2)
                            }

                        })
                        this.goodsL = res.data
                    } else {
                        res.data.forEach(item => {
                            item.name = name
                            item.goodsSkuName = '礼包套餐一'
                        })
                        this.goodsL = res.data
                        console.log(this.goodsL)
                    }
                    this.shippingTemplateId = res.data.shippingTemplateIdOrigin
                }
            })
        },
        //选择商品
        handleSelectGoods1(scope) {
            this.seletedGoods1 = []
            if (!scope.row.selected) {
                for (let i = 0; i < this.goodsList1.length; i++) {
                    if (i == scope.$index) {
                        this.goodsList1[scope.$index].selected = !this.goodsList1[scope.$index].selected
                    } else {
                        this.goodsList1[i].selected = false;
                    }
                }
                this.getSkuList(scope.row.id, '2', scope.row.name)
                this.seletedGoods1.push(scope.row.id)
            } else {
                this.goodsList1[scope.$index].selected = false;
                this.goodsL=[]
            }
            console.log(this.seletedGoods1)
            this.$forceUpdate()
        },
        onGoodsSizeChange(e) {
            this.goodsPageSize = e;
            this.getGoodsList()
        },
        onGoodsCurrentChange(e) {
            this.goodsPageNo = e;
            this.getGoodsList()
        },
        onGoodsSizeChange1(e) {
            this.goodsPageSize1 = e;
            this.getGoodsList()
        },
        onGoodsCurrentChange1(e) {
            this.goodsPageNo1 = e;
            this.getGoodsList()
        },
        selectG(val) {
            this.gType = val
            this.goodsL = []
            this.seletedGoods = []
            this.seletedGoods1 = []
            this.name = ''
            this.getGoodsList()//获取商品数据
        },
        getT(type) {
            return new Promise((resolve, reject) => {
                let data = {
                    type: type
                }
                this.axios.post('/marketActivate/seckillGoodsIdAllList', data).then(res => {
                    if (res.code === 0) {
                        resolve(res.data)
                    }
                })

            })

        },
        //获取商品数据
        async getGoodsList() {

            if (this.gType == 1) {
                let seckillGoodsIds = await this.getT('1')
                let data = {
                    pageNo: this.goodsPageNo,
                    pageSize: this.goodsPageSize,
                    nameOrGoodsNo: this.name,
                    // goodsName: this.name,
                    // code: this.goodsNo,
                    status: '1',
                    seckillGoodsIds: seckillGoodsIds
                }
                this.axios.post('/goods/seckillPageList', data).then(res => {
                    if (res.code === 0) {
                        res.data.list.forEach(item => {
                            item.selected = false
                        })
                        this.goodsList = res.data.list;
                        console.log(this.seletedGoods)
                        this.seletedGoods.forEach(item => {
                            this.goodsList.forEach(el => {
                                if (item == el.id) {
                                    el.selected = true;
                                }
                            })
                        })
                        this.goodsTotalNum = res.data.totalNum
                    } else {
                        console.log('goodsPageList - 失败', type)
                    }
                })
            } else {
                let seckillGoodsIds = await this.getT('2')
                let data = {
                    pageNo: this.goodsPageNo1,
                    pageSize: this.goodsPageSize1,
                    nameOrGoodsNo: this.name,
                    // goodsName: this.name,
                    // code: this.goodsNo,
                    status: '1',
                    seckillGoodsIds: seckillGoodsIds
                }
                this.axios.post('/giftPackage/seckillPageList', data).then(res => {
                    if (res.code === 0) {
                        res.data.list.forEach(item => {
                            item.selected = false
                        })
                        this.goodsList1 = res.data.list;
                        this.seletedGoods1.forEach(item => {
                            this.goodsList1.forEach(el => {
                                if (item == el.id) {
                                    el.selected = true;
                                }
                            })
                        })
                        this.goodsTotalNum1 = res.data.totalNum
                    } else {
                        console.log('goodsPageList - 失败', type)
                    }
                })
            }

        },
        submitSetting() {
            let data = {
                image: this.form.banner,
                id: ''
            }
            this.axios.post('/marketActivateSeckill/update', data)
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        this.$message.success('设置成功')
                        // this.getPageList()
                        this.isS = false
                    }
                })
        },
        getImage(val) {
            console.log(val)
            this.form.banner = val
        },
        //表格合并行和列
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            let pos = 0
            let len = this.goodsL.length
            for (let i = 0; i < len; i++) {
                const item = this.goodsL[i]
                if (i === 0) {
                    item.$rows = 1
                    pos = 0
                }
                if (i !== 0) {
                    if (item.name === this.goodsL[i - 1].name) {
                        item.$rows = 0
                        this.goodsL[pos].$rows = this.goodsL[pos].$rows + 1
                    } else {
                        item.$rows = 1
                        pos = i
                    }
                }
            }
            if (columnIndex === 0) {
                return {
                    rowspan: row.$rows,
                    colspan: row.$rows ? 1 : 0,
                };
            }
        },
        pUp(val) {
            this.isAlot = true
            if (this.dId1.length == 0) {
                this.$message.warning('请选择商品')
                return
            } else {
                this.isD = true
            }


        },
        optionG() {
            this.dialogGoods = true
        },
        options(type, row) {
            this.seletedGoods = []
            this.seletedGoods1 = []
            if (type == 'add') {
                this.optionsTitle = '选择商品'
                this.isLook = true
                this.goodsL = []
                this.shippingTemplateId = ''
                this.detail = {}
                this.value3 = []
                this.name = ''
                this.sort = ''
                this.getGoodsList()
                this.getModelsList()
                this.eId = ''
                this.tableDataF = []
            } else if (type == 'edit') {
                this.optionsTitle = '活动商品设置'
                this.isLook = false
                this.detail = {}
                this.tableDataF = []
                this.getModelsList()
                this.getDetail(row.goodsType, row.id)
                this.sType = row.goodsType
                this.eId = row.id
            }
            this.dialogGoods = true
        },
        getDetail(type, id) {
            this.value3 = []
            let data = {
                id: id
            }
            // if (type == 1) {
            //     data = {
            //         goodsId: id,

            //     }
            // } else {
            //     data = {
            //         giftId: id,

            //     }
            // }
            this.axios.post('/marketActivateSeckill/detail', data)
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        res.data.skuList.forEach(item => {
                            item.name = res.data.name
                        })
                        if (type == 1) {
                            this.goodsL = res.data.skuList
                        } else {
                            res.data.skuList.forEach(item => {
                                item.goodsSku = '礼包套餐一'
                            })
                            this.goodsL = res.data.skuList
                        }

                        this.shippingTemplateId = res.data.shippingTemplateId
                        if (this.shippingTemplateId) {
                            this.getTransportModel(this.shippingTemplateId)
                        }

                        this.value3.push(res.data.activateStartTime)
                        this.value3.push(res.data.activateEndTime)
                        console.log(this.value3)
                        this.name = res.data.name
                        this.sort = res.data.sort
                    }
                })
        },
        deleteT(id) {
            this.isD = true
            // let msg = '是否确认删除该商品？'
            // this.$confirm(msg, '温馨信息', {
            //     title: '温馨信息',
            //     confirmButtonText: '确定',
            //     cancelButtonText: '取消',
            //     type: 'warning'
            // }).then(() => {
            //     this.axios.post('/tags/deleteTagGood', { id: id })
            //         .then(res => {
            //             console.log(res)
            //             if (res.code == 0) {
            //                 this.$message.success('删除成功')
            //                 this.getShopList()
            //                 this.getPageList()
            //             }
            //         })
            // }).catch(() => {
            //     this.$message({
            //         type: 'info',
            //         message: '已取消'
            //     })
            // })
        },
        add(val) {
            this.$router.push({
                name: 'addTag',
                query: {
                    id: val
                }
            })
        },
        getShopList() {
            this.goodsSearch.pageNo = this.page1.pageNo
            this.goodsSearch.pageSize = this.page1.pageSize
            this.axios.post('/tags/getGoodsPageByTag', this.goodsSearch)
                .then(res => {
                    console.log(res)
                    this.goodsList = res.data.list;
                    this.page1.totalNum = res.data.totalNum;

                })
        },
        look(id) {
            this.dialogGoods = true
            this.goodsSearch.tagId = id
            this.getShopList()
        },
        isStart(val) {
            this.isS = true
            this.sName = val.statusL
            this.tagId = val.id
            if (val.statusL == '启用') {
                this.isStatus = true
            } else {
                this.isStatus = false
            }

        },
        upStatus() {
            let data = {
                id: this.tagId,
                status: this.isStatus,
            }
            this.axios.post('/tags/updateStatus', data)
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        this.$message.success('操作成功')
                        this.isS = false
                        this.getPageList()
                    }

                })
        },
        exportFn() {
            this.exporting = true
            if (this.value1 && this.value1.length > 0) {
                this.searchForm.joinTimeStart = this.value1[0];
                this.searchForm.joinTimeEnd = this.value1[1];
            } else {
                this.searchForm.joinTimeStart = ''
                this.searchForm.joinTimeEnd = ''
            }
            if (this.value2) {
                this.searchForm.lastActiveTimeStart = this.value2[0];
                this.searchForm.lastActiveTimeEnd = this.value2[1];
            } else {
                this.searchForm.lastActiveTimeStart = ''
                this.searchForm.lastActiveTimeEnd = ''
            }
            this.axios.post('/users/exportList', this.searchForm)
                .then(res => {
                    console.log(res)
                    this.exporting = false;
                    if (res.code === 0) {
                        this.downloadlink(res.data)
                    }
                })
        },
        fetchData(type) {
            this.page.pageNo = 1;
            if (type == 'reset') {
                this.$refs['searchForm'].resetFields()
                this.value1 = []
                this.searchForm.name = ''
                this.searchForm.goodsNo = ''
                this.searchForm.status = ''
                this.searchForm.activateStartTime = ''
                this.searchForm.activateEndTime = ''
            }
            if (this.value1 && this.value1.length > 0) {
                this.searchForm.activateStartTime = this.value1[0];
                this.searchForm.activateEndTime = this.value1[1];
            } else {
                this.searchForm.activateStartTime = ''
                this.searchForm.activateEndTime = ''
            }
            this.getPageList()
        },
        fetchData1(type) {
            this.page.pageNo = 1;
            this.goodsPageNo = 1;
            this.goodsPageNo1 = 1;
            if (type == 'reset') {
                this.name = ''
                this.goodsNo = ''
            }
            this.getGoodsList()
        },
        getPageList() {
            if (this.value1 && this.value1.length > 0) {
                this.searchForm.activateStartTime = this.value1[0];
                this.searchForm.activateEndTime = this.value1[1];
            } else {
                this.searchForm.activateStartTime = ''
                this.searchForm.activateEndTime = ''
            }
            this.searchForm.pageNo = this.page.pageNo;
            this.searchForm.pageSize = this.page.pageSize;
            this.axios.post('/marketActivateSeckill/goodsPageList', this.searchForm)
                .then(res => {
                    res.data.list.forEach(item => {
                        item.mainImageArr = []
                        item.mainImageArr.push(item.image)
                        item.seckillPriceMin = Number(item.seckillPriceMin).toFixed(2)
                        item.seckillPriceMax = Number(item.seckillPriceMax).toFixed(2)
                        if (item.status == 1) {
                            item.statusLabel = '禁用'
                            item.statusL = '启用'
                        } else {
                            item.statusLabel = '启用'
                            item.statusL = '禁用'
                        }
                    })
                    this.list = res.data.list;
                    this.page.totalNum = res.data.totalNum;
                })
        },
        onMultipleSelection(e) {
            this.dId1 = []
            e.forEach(item => {
                this.dId1.push(item.id)
            })
        },
        handleSizeChange(e) {
            this.page.pageSize = e;
            this.page.pageNo = 1;
            this.getPageList()
        },
        handleCurrentChange(e) {
            this.page.pageNo = e;
            this.getPageList()
        },
        handleSizeChange1(e) {
            this.page1.pageSize = e;
            this.page1.pageNo = 1;
            this.getShopList()
        },
        handleCurrentChange1(e) {
            this.page1.pageNo = e;
            this.getShopList()
        },
        todetail(row) {
            this.$router.push({
                name: 'userDetail',
                query: {
                    id: row.id
                }
            })
        }
    }
}
</script>
  
<style scoped lang="scss">
::v-deep .el-table--border .el-table__cell {
    text-align: center !important
}

.info {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 30px;
    color: #303033;
    opacity: 1;
    text-align: center;
}

.p-info {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 16px;
    color: #909099;
    margin-bottom: 18px
}

::v-deep .el-radio-button__orig-radio:checked+.el-radio-button__inner {
    color: #2d46ee;
    background-color: #fff !important;
    border-color: #2d46ee;
    box-shadow: -1px 0 0 0 #2d46ee;
}

.start {
    width: 10px;
    height: 10px;
    background: #13ce4b;
    border-radius: 50%;
    opacity: 1;
    margin-top: 8px;
    margin-right: 5px;
}

.end {
    width: 10px;
    height: 10px;
    background: #f63c56;
    border-radius: 50%;
    opacity: 1;
    margin-top: 8px;
    margin-right: 5px;
}

.btn-y {
    width: 64px;
    height: 32px;
    background: #2D46EE;
    opacity: 1;
    border-radius: 16px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 32px;
    color: #FFFFFF;
    text-align: center;
    cursor: pointer;
}

.btn-s {
    width: 64px;
    height: 32px;
    background: #E9ECFE;
    opacity: 1;
    border-radius: 16px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 32px;
    color: #2D46EE;
    text-align: center;
    cursor: pointer;
}

.u-btn {
    width: 92px;
    height: 34px;
    background: #FFFFFF;
    border: 1px solid #2D46EE;
    opacity: 1;
    border-radius: 3px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 36px;
    color: #2D46EE;
    text-align: center;
    cursor: pointer;
    margin-right: 18px;
}

/deep/ .el-dialog {
    // display: flex;
    // flex-direction: column;
    // margin: 0 !important;
    // position: absolute;
    // top: 50%;
    // left: 50%;
    // transform: translate(-50%, -50%);
    // max-height: calc(100% - 30px);
    // max-width: calc(100% - 30px);

    .el-dialog__body {
        padding: 30px 25px;
        padding-top: 10px !important;
        // height: 800px;
        flex: 1;
        overflow: auto;
    }
}

.info-q {
    width: 124px;
    height: 40px;
    line-height: 40px;
    background: #ffffff;
    border: 1px solid #909099;
    opacity: 1;
    border-radius: 3px;
    text-align: center;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #909099;
    margin-right: 18px;
    cursor: pointer;
}

.info-s {
    width: 126px;
    height: 40px;
    line-height: 40px;
    background: #2d46ee;
    opacity: 1;
    border-radius: 3px;
    text-align: center;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    cursor: pointer;
}

::v-deep .el-input--prefix .el-input__inner {
    padding-left: 37px;
}

.title {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

#base-list {
    margin-top: 20px;
}

:deep(#base-list .lb-table .el-table .el-table__body .el-table__row .el-table__cell:last-child .cell div) {
    display: inline-block;

    a {
        margin: 0 5px;
    }
}

.search-form {
    // margin-top: 20px;
    display: flex;
    flex-wrap: wrap;

    .el-form-item {
        /deep/ .el-form-item__label {
            width: 100px;
            text-align: right;
            vertical-align: middle;
            float: left;
            box-sizing: border-box;
        }

        /deep/ .el-form-item__content {
            display: block;
            margin-left: 100px;

            .el-cascader,
            .el-select {
                width: 100%;
            }
        }
    }

    .form-btn {
        /deep/ .el-form-item__content {
            line-height: 36px;
            margin-left: 50px;
        }
    }
}

/deep/ .el-table__row {
    .el-table__cell {
        padding: 12px 0;
    }
}

/deep/ .el-table {
    color: #303033;
}
</style>
  
  